module.exports = __webpack_public_path__ + "static/media/tu.c69b8261.svg";